export class ValidationResult {
  public isValid: boolean;
  public errors: Array<string>;

  public constructor() {
    this.isValid = true;
    this.errors = new Array<string>();
  }
}
